import { getUserToken } from '@/services/api'
import { isChrome } from '@/common/lib/strLib'

const extensionINFO = Object.freeze({
  extensionID: 'cooadaolpinhaghnkkimdadhahbjjocb',
  extensionStoreURL: 'https://chrome.google.com/webstore/detail/tape-screen-recorder/cooadaolpinhaghnkkimdadhahbjjocb',
  extensionElementClassName: 'tape-extension',
})

// Check if the browser is Chrome
function isChromeBrowser() {
  return isChrome() === 'Chrome'
}

// Helper function to send message to extension
function sendMessageToExtension(message) {
  chrome.runtime.sendMessage(extensionINFO.extensionID, message)
}

// Check if the extension is installed
export function checkIsExtensionInstalled() {
  if (!isChromeBrowser()) {
    return
  }

  let tapeExtension = document.getElementsByClassName(extensionINFO.extensionElementClassName)

  if (tapeExtension.length > 0) {
    return true
  } else {
    return false
  }
}

// Open extension store page
export function installExtension() {
  if (!isChromeBrowser()) {
    return
  }

  window.open(extensionINFO.extensionStoreURL, '_blank', 'noopener,noreferrer')
}

//Send Token message to extension
export async function sendUserTokenToExtension(vm, currentUser) {
  if (!isChromeBrowser()) {
    return
  }

  if (currentUser && currentUser.uid) {
    let result = await getUserToken(vm, currentUser.uid)

    try {
      // console.error('sendMessageToTape Tape!!!!!!!!!!!!!!!', result)
      sendMessageToExtension({ type: 'tape', userToken: result.token })
    } catch (error) {
      //handle error silently
    }
  }
}

//Send message to Extension that the page has been loaded
export async function sendPageLoadedMessageToTape() {
  if (!isChromeBrowser()) {
    return
  }

  try {
    sendMessageToExtension({ type: 'page-loaded' })
  } catch (error) {
    //handle error silently
  }
}

//Send message to extension to sign out
export async function sendMessageToExtensionToSignOut() {
  if (!isChromeBrowser()) {
    return
  }

  try {
    sendMessageToExtension({ type: 'tapeSingOut' })
  } catch (error) {
    //handle error silently
  }
}
